import {
  Component, computed, input, output,
} from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';

import { DropdownOption, DropdownValue } from '../../../models/field.model';
import { TablePage } from '../../../models/table.model';
import { DropdownComponent } from '../../dropdown/dropdown.component';
import { InlineSvgComponent } from '../../inline-svg/inline-svg.component';

import { tablePageRange } from './table-paginator.model';

@Component({
  selector: 'ui-table-paginator',
  imports: [ TranslocoModule, DropdownComponent, InlineSvgComponent ],
  templateUrl: './table-paginator.component.html',
  styleUrl: './table-paginator.component.scss',
})
export class TablePaginatorComponent {
  page = input.required<TablePage>();
  totalCount = input.required<number>();
  /** The sizes offered under "Items per page"; with fewer than two the selector is hidden. */
  pageSizeOptions = input<number[]>([]);
  disabled = input<boolean>(false);

  pageChange = output<TablePage>();

  range = computed(() => tablePageRange(this.page(), this.totalCount()));

  rangeParams = computed(() => ({
    from: this.range().from,
    to: this.range().to,
    total: this.totalCount(),
  }));

  sizeOptions = computed<DropdownOption[]>(() =>
    this.pageSizeOptions().map((size) => ({ label: String(size), value: size })));

  onFirst(): void {
    this.goTo(0);
  }

  onPrevious(): void {
    this.goTo(this.page().index - 1);
  }

  onNext(): void {
    this.goTo(this.page().index + 1);
  }

  onLast(): void {
    this.goTo(this.range().pageCount - 1);
  }

  /** A new size starts over at the first page, since the old index points at different rows. */
  onPageSize(size: DropdownValue | undefined): void {
    if (typeof size !== 'number' || size === this.page().size) {
      return;
    }

    this.pageChange.emit({ index: 0, size });
  }

  private goTo(index: number): void {
    if (index !== this.page().index) {
      this.pageChange.emit({ ...this.page(), index });
    }
  }
}
